<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="row background-light-gray border-bottom border-dark-subtle p-3 m-0 z-max d-flex align-items-center height-details-header">
        <div (click)="back()"
             class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2"
             type="button">
            <i class="fa-solid fa-chevron-left color-secondary-information m-auto"></i>
        </div>
        <div class="col-2 m-0 d-flex justify-content-center">
            <app-water-point-svg/>
        </div>
        @if (!loading) {
            <div class="col-8 m-0">
                <div class="fw-bold">Alter {{ asset()?.name || '-' }}</div>
            </div>
        }
        <div (click)="close()"
             class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2"
             type="button">
            <i class="fa-solid fa-x color-secondary-information m-auto"></i>
        </div>
    </div>
    <div class="d-flex flex-column gap-3 p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        <div>
            <div>Name</div>
            <input (input)="setName($event)"
                    [disabled]="loading || !canBeAltered"
                    class="form-control"
                    datatype="text"
                    id="name"
                    name="name"
                    placeholder="Name"
                    type="text"
                    value="{{asset()?.name}}">
        </div>
        <div>
            <div class="row">
                <div class="col">Latitude</div>
                <div class="col">Longitude</div>
            </div>
            <div class="row">
                <div class="col">
                    <input (input)="setLatitude($event)"
                            [disabled]="loading || !canBeAltered"
                            class="mb-2 form-control"
                            datatype="text"
                            id="latitude"
                            name="latitude"
                            placeholder="Latitude"
                            type="number"
                            value="{{asset()?.location?.coords![0] || 'Latitude'}}">
                </div>
                <div class="col">
                    <input (input)="setLongitude($event)"
                            [disabled]="loading || !canBeAltered"
                            class="mb-2 form-control"
                            datatype="text"
                            id="longitude"
                            name="longitude"
                            placeholder="Longitude"
                            type="number"
                            value="{{asset()?.location?.coords![1] || 'Longitude'}}">
                </div>
            </div>
        </div>
        <app-generic-button
            (click)="onDropAPin()"
            description="Drop a pin for water-sample point"
            [alwaysShowText]="true"
            [buttonText]="'Drop a pin'"
            [disabled]="loading || !canBeAltered || !dropAPinEnabled"
            [loading]="loading"
            [primaryIcon]="'fa-solid fa-pin'"></app-generic-button>

        <div>
            <div>Nominal value</div>
            <div class="d-flex gap-3">
                <input (input)="setNominalValue($event)"
                        [disabled]="loading || !canBeAltered"
                        class="mb-2 form-control"
                        datatype="text"
                        id="nominalValue"
                        name="nominalValue"
                        type="number"
                        placeholder="Nominal value"
                        [value]="deviceAssociationWithThresholds()?.sampleThresholds?.WaterLevel?.nominalValue">
                <app-info-button [message]="nominalValueInfo()"/>
            </div>
        </div>
        <div>
            <div>Datum</div>
            <div class="d-flex gap-3">
                <input (input)="setDatum($event)"
                        [disabled]="loading || !canBeAltered"
                        class="mb-2 form-control"
                        datatype="text"
                        id="datum"
                        name="datum"
                        type="number"
                        placeholder="Datum"
                        [value]="deviceAssociationWithThresholds()?.sampleThresholds?.WaterLevel?.datum">
                <app-info-button [message]="datumInfo()"/>
            </div>
        </div>
        <div>
            <div>High alert threshold</div>
            <div class="d-flex gap-3">
                <input (input)="setHighAlert($event)"
                        [disabled]="loading || !canBeAltered"
                        class="mb-2 form-control"
                        datatype="text"
                        id="highAlert"
                        name="highAlert"
                        type="number"
                        placeholder="High alert threshold"
                        [value]="deviceAssociationWithThresholds()?.sampleThresholds?.WaterLevel?.thresholds?.HIGH_ALERT">
                <app-info-button [message]="highAlertInfo()"/>
            </div>
        </div>
        <div>
            <div>High warning threshold</div>
            <div class="d-flex gap-3">
                <input (input)="setHighWarning($event)"
                        [disabled]="loading || !canBeAltered"
                        class="mb-2 form-control"
                        datatype="text"
                        id="highWarning"
                        name="highWarning"
                        type="number"
                        placeholder="High warning threshold"
                        [value]="deviceAssociationWithThresholds()?.sampleThresholds?.WaterLevel?.thresholds?.HIGH_WARNING">
                <app-info-button [message]="highWarningInfo()"/>
            </div>
        </div>
        <div>
            <div>Low warning threshold</div>
            <div class="d-flex gap-3">
                <input (input)="setLowWarning($event)"
                        [disabled]="loading || !canBeAltered"
                        class="mb-2 form-control"
                        datatype="text"
                        id="lowWarning"
                        name="lowWarning"
                        type="number"
                        placeholder="Low warning threshold"
                        [value]="deviceAssociationWithThresholds()?.sampleThresholds?.WaterLevel?.thresholds?.LOW_WARNING">
                <app-info-button [message]="lowWarningInfo()"/>
            </div>
        </div>
        <div>
            <div>Low alert threshold</div>
            <div class="d-flex gap-3">
                <input (input)="setLowAlert($event)"
                        [disabled]="loading || !canBeAltered"
                        class="mb-2 form-control"
                        datatype="text"
                        id="lowAlert"
                        name="lowAlert"
                        type="number"
                        placeholder="Low alert threshold"
                        [value]="deviceAssociationWithThresholds()?.sampleThresholds?.WaterLevel?.thresholds?.LOW_ALERT">
                <app-info-button [message]="lowAlertInfo()"/>
            </div>
        </div>
        <app-generic-button
            (click)="applyChanges()"
            description="Apply changes to water-sample point"
            [alwaysShowText]="true"
            [buttonText]="'Apply changes'"
            [disabled]="loading || !canBeAltered"
            [loading]="loading"
            [primaryIcon]="'fa-solid fa-check'"/>
    </div>
    <app-spinner [loading]="loading" [style]="'width: 2rem; height: 2rem;'"></app-spinner>
</div>
